import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconCursor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCursor1"><G ClipPath="url(#clip0_5580_5671)"><Path d="M24.1982 9.91119L1.83594 1.83594L9.91119 24.1982L14.2594 14.2594L24.1982 9.91119Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_5580_5671"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconCursor1;
